<template>
  <section class="p-article3">
    <section class="c-visible-pc" v-if="$store.state.isPc">
      <section class="cm-width c-pb-164 news-wrap">
        <section class="news-left">
          <div>
            <p class="c-fs-24 c-fw-b">第五届Zabbix峰会中国站</p>
            <div class="c-mt-12 c-fs-16 c-c-text-grey">
              <span>2020-9-20 10:00</span><span class="c-ml-28">作者：猫维</span>
            </div>
          </div>
          <div class="c-mt-24 c-lh-28  content-wrap">
            <p>IT行业，每时每刻都有新技术以惊人的速度改变着格局，容器、微服务、云端部署、serverless……更多应用、更灵活的基础架构、更丰富的服务正在产生更庞杂的数据，那句著名的“无法衡量的就无法管理”比以往任何时候都真实，企业对新一代监控解决方案的需求越来越强烈！</p>
            <p>9月25-26日加入Zabbix中国峰会，学习前沿的监控技术，聆听多元的行业案例，分享技术实践，参加Zabbix实践操作工作坊，还有产品Demo展台、合作伙伴展台、特邀展台展示等您来参观！</p>
          </div>
          <div class="c-mb-48 video-wrap">
            <a href="https://www.bilibili.com/video/BV1UJ411Y71i/" target="_blank" class="pic-video"></a>
          </div>
          <div>
            <div class="area">
              <p class="section-title">为什么参加Zabbix峰会</p>
              <section class="fast card">
                <div class="item">
                  <img src="../../assets/resolution/icon/icon12.png">
                  <div>
                    <p class="desc">与您分享Zabbix的过去<br>邀您参与Zabbix的未来</p>
                  </div>
                </div>
                <div class="item">
                  <img src="../../assets/resolution/icon/icon19.png">
                  <div>
                    <p class="desc">聆听行业运用案例<br>了解行业发展趋势</p>
                  </div>
                </div>
                <div class="item">
                  <img src="../../assets/resolution/icon/icon15.png">
                  <div>
                    <p class="desc">寻找潜在合作伙伴<br>结识业内知名企业</p>
                  </div>
                </div>
                <div class="item">
                  <img src="../../assets/resolution/icon/icon14.png">
                  <div>
                    <p class="desc">原厂团队多个主题分享<br>探讨创新和转型之道</p>
                  </div>
                </div>
                <div class="item">
                  <img src="../../assets/resolution/icon/icon16.png">
                  <div>
                    <p class="desc">参加实践操作<br>见证Zabbix的顶尖玩法</p>
                  </div>
                </div>
                <div class="item">
                  <img src="../../assets/resolution/icon/icon13.png">
                  <div>
                    <p class="desc">五折培训认证，成为<br>国内首批Zabbix5.0认证专家</p>
                  </div>
                </div>
              </section>
            </div>
          </div>
          <div>
            <div class="area">
              <section class="">
                <p class="c-mb-20 section-title">峰会精彩活动</p>
                <section class="active card">
                  <div class="item">
                    <img src="../../assets/news/active1.png">
                    <div>
                      <p class="title">Workshop实践操作</p>
                      <p class="desc">9月25日 | 上午</p>
                    </div>
                  </div>
                  <div class="item">
                    <img src="../../assets/news/active2.png">
                    <div>
                      <p class="title">重磅主题演讲</p>
                      <p class="desc">9月25-26日</p>
                    </div>
                  </div>
                  <div class="item">
                    <img src="../../assets/news/active3.png">
                    <div>
                      <p class="title">认证培训&考试享折扣</p>
                      <p class="desc">ZCS&ZCP | 26日上午</p>
                    </div>
                  </div>
                  <div class="item">
                    <img src="../../assets/news/active4.png">
                    <div>
                      <p class="title">Zabbix圆桌晚宴</p>
                      <p class="desc">9月25日 | 晚</p>
                    </div>
                  </div>
                  <div class="item">
                    <img src="../../assets/news/active5.png">
                    <div>
                      <p class="title">趣味派对</p>
                      <p class="desc">9月26日 | 晚</p>
                    </div>
                  </div>
                </section>
              </section>
            </div>
          </div>
          <div>
            <p class="c-fs-20 c-c-text-blue c-ta-c c-mt-28">峰会场地</p>
            <div class="c-mt-24 c-lh-28  content-wrap">
              <p>2020 Zabbix峰会将于深圳湾万怡酒店（Courtyard by Marriott, SHENZHEN BAY）举办。</p>
              <p>深圳比邻香港，是中国改革开放的窗口和新兴移民城市，创造了举世瞩目的“深圳速度”。 深圳没有演绎 过皇朝繁华落寞，简单得只剩下明天比今天更璀璨的辉煌。强大的电子工业和新兴产业集群汇集于此，科技创新活力更是独 占鳌头，具有非凡的创新和探索精神。每一位来到这里的朋友都能以一个崭新的视角，用眼睛去发现深圳之美，用心灵去感 受深圳之魅。</p>
              <p>深圳湾万怡酒店地处繁荣发展的粤港澳经济开发区“粤港澳大湾经济区”内，占据深圳湾超级总部基地核心区域。优越的地理位置和前沿尖端的设施设备，融合现代活力与舒适便捷，本次所选峰会场地将为每一位客人展现时尚热情的设计风格、提供妥帖细致的个性服务。</p>
            </div>
            <img src="../../assets/news/hotel.jpg" class="c-w-100">
            <img src="../../assets/news/map.png" class="c-w-100 c-mt-32">
          </div>
          <div class="c-mt-40">
            <p class="c-mb-8">原文地址：</p>
            <a class="c-c-text-grey c-ww-w" target="_blank" href="https://www.zabbix.com/cn/events/conference_china_2020#venue">
              https://www.zabbix.com/cn/events/conference_china_2020#venue
            </a>
          </div>
        </section>

        <section class="news-right">
          <p class="c-fs-16 c-mb-16 c-fw-b">精选内容</p>
          <div>
            <p v-for="(item, index) in recommendList" :key="index" class="c-fs-12 c-cs-p c-mb-8 c-c-text-black c-ellipsis-1 news-link" @click="toUrl(item.url)">{{index + 1}}、{{item.title}}</p>
          </div>
          <div class="c-mt-48 c-mb-24 c-fs-12 c-c-text-black">
            <p class="c-fs-16 c-c-text-color c-mb-16 c-fw-b">联系我们</p>
            <p class="c-mb-8">安徽高颐科技有限公司</p>
            <p class="c-mb-8">地址：安徽省池州经济技术开发区电子信息产业园7楼</p>
            <p class="c-mb-8">电话：4006-111-696</p>
            <p>邮箱：joshua#quaee.com</p>
          </div>
          <img src="../../assets/header/QR-code1.png" class="code">
        </section>
      </section>
    </section>
    <section class="c-visible-mobile" v-if="!$store.state.isPc">
      <section class="cm-width c-mt-40 c-pb-40 news-wrap-mobile">
        <section class="c-fs-12 news-left">
          <div>
            <p class="c-fs-19 c-fw-b">第五届Zabbix峰会中国站</p>
            <div class="c-mt-12 c-fs-12 c-c-text-grey">
              <span>2020-9-20 10:00</span><span class="c-ml-28">作者：猫维</span>
            </div>
          </div>
          <div class="c-mt-20 c-lh-28  content-wrap">
            <p>IT行业，每时每刻都有新技术以惊人的速度改变着格局，容器、微服务、云端部署、serverless……更多应用、更灵活的基础架构、更丰富的服务正在产生更庞杂的数据，那句著名的“无法衡量的就无法管理”比以往任何时候都真实，企业对新一代监控解决方案的需求越来越强烈！</p>
            <p>9月25-26日加入Zabbix中国峰会，学习前沿的监控技术，聆听多元的行业案例，分享技术实践，参加Zabbix实践操作工作坊，还有产品Demo展台、合作伙伴展台、特邀展台展示等您来参观！</p>
          </div>
          <div class="c-mb-32 video-wrap">
            <a href="https://www.bilibili.com/video/BV1UJ411Y71i/" target="_blank" class="pic-video"></a>
          </div>
          <div>
            <div class="area">
              <p class="section-title">为什么参加Zabbix峰会</p>
              <section class="fast card">
                <div class="item">
                  <img src="../../assets/resolution/icon/icon12.png">
                  <div>
                    <p class="desc">与您分享Zabbix的过去邀您参与Zabbix的未来</p>
                  </div>
                </div>
                <div class="item">
                  <img src="../../assets/resolution/icon/icon19.png">
                  <div>
                    <p class="desc">聆听行业运用案例了解行业发展趋势</p>
                  </div>
                </div>
                <div class="item">
                  <img src="../../assets/resolution/icon/icon15.png">
                  <div>
                    <p class="desc">寻找潜在合作伙伴结识业内知名企业</p>
                  </div>
                </div>
                <div class="item">
                  <img src="../../assets/resolution/icon/icon14.png">
                  <div>
                    <p class="desc">原厂团队多个主题分享探讨创新和转型之道</p>
                  </div>
                </div>
                <div class="item">
                  <img src="../../assets/resolution/icon/icon16.png">
                  <div>
                    <p class="desc">参加实践操作见证Zabbix的顶尖玩法</p>
                  </div>
                </div>
                <div class="item">
                  <img src="../../assets/resolution/icon/icon13.png">
                  <div>
                    <p class="desc">五折培训认证，成为国内首批Zabbix5.0认证专家</p>
                  </div>
                </div>
              </section>
            </div>
          </div>
          <div>
            <div class="area">
              <section class="">
                <p class="c-mb-20 section-title">峰会精彩活动</p>
                <section class="active card">
                  <div class="item">
                    <img src="../../assets/news/active1.png">
                    <div>
                      <p class="title">Workshop实践操作</p>
                      <p class="desc">9月25日 | 上午</p>
                    </div>
                  </div>
                  <div class="item">
                    <img src="../../assets/news/active2.png">
                    <div>
                      <p class="title">重磅主题演讲</p>
                      <p class="desc">9月25-26日</p>
                    </div>
                  </div>
                  <div class="item">
                    <img src="../../assets/news/active3.png">
                    <div>
                      <p class="title">认证培训&考试享折扣</p>
                      <p class="desc">ZCS&ZCP | 26日上午</p>
                    </div>
                  </div>
                  <div class="item">
                    <img src="../../assets/news/active4.png">
                    <div>
                      <p class="title">Zabbix圆桌晚宴</p>
                      <p class="desc">9月25日 | 晚</p>
                    </div>
                  </div>
                  <div class="item">
                    <img src="../../assets/news/active5.png">
                    <div>
                      <p class="title">趣味派对</p>
                      <p class="desc">9月26日 | 晚</p>
                    </div>
                  </div>
                </section>
              </section>
            </div>
          </div>
          <div>
            <p class="c-fs-15 c-c-text-blue c-ta-c">峰会场地</p>
            <div class="c-mt-24 c-lh-28  content-wrap">
              <p>2020 Zabbix峰会将于深圳湾万怡酒店（Courtyard by Marriott, SHENZHEN BAY）举办。</p>
              <p>深圳比邻香港，是中国改革开放的窗口和新兴移民城市，创造了举世瞩目的“深圳速度”。 深圳没有演绎 过皇朝繁华落寞，简单得只剩下明天比今天更璀璨的辉煌。强大的电子工业和新兴产业集群汇集于此，科技创新活力更是独 占鳌头，具有非凡的创新和探索精神。每一位来到这里的朋友都能以一个崭新的视角，用眼睛去发现深圳之美，用心灵去感 受深圳之魅。</p>
              <p>深圳湾万怡酒店地处繁荣发展的粤港澳经济开发区“粤港澳大湾经济区”内，占据深圳湾超级总部基地核心区域。优越的地理位置和前沿尖端的设施设备，融合现代活力与舒适便捷，本次所选峰会场地将为每一位客人展现时尚热情的设计风格、提供妥帖细致的个性服务。</p>
            </div>
            <img src="../../assets/news/hotel.jpg" class="c-w-100">
            <img src="../../assets/news/map.png" class="c-w-100 c-mt-32">
          </div>
          <div class="c-mt-40">
            <p class="c-mb-8">原文地址：</p>
            <a class="c-c-text-grey c-ww-w" target="_blank" href="https://www.zabbix.com/cn/events/conference_china_2020#venue">
              https://www.zabbix.com/cn/events/conference_china_2020#venue
            </a>
          </div>
        </section>
      </section>
    </section>
  </section>
</template>

<script>
const recommendList = [{
  title: '第五届Zabbix峰会 中国深圳',
  url: '/article4'
}, {
  title: 'QUAEE高颐和Zabbix达成战略合作 成为Zabbix中国区重要合作伙伴',
  url: '/article1'
}, {
  title: 'Grafana如何助力Zabbix，打造漂亮的监控界面？',
  url: '/article2'
}
// {
//   title: '第五届Zabbix峰会中国站',
//   url: '/article3'
// }
]
export default {
  data () {
    return {
      recommendList: recommendList
    }
  },
  methods: {
    toUrl (url) {
      if (url) {
        this.$router.push(url)
      }
    }
  }
}
</script>

<style lang="scss">
.p-article3 {
  .news-wrap {
    display: flex;
    justify-content: space-between;
    margin-top: 80px;
    .news-left {
      width: 70%;
      .content-wrap {
        p {
          margin-bottom: 20px;
        }
      }
      .video-wrap {
        width: 100%;
        height: 400px;
        .pic-video {
          width: 100%;
          height: 100%;
          display: block;
          background: url('../../assets/news/video.jpg');
          background-position-x: center;
          background-size: cover;
        }
      }
      .area {
        padding-bottom: 30px;
        // padding-top: 50px;
        .section-title {
          font-size: 20px;
          color: $text-blue;
          text-align: center;
          @media screen and (max-width: $max-width-standard) {
            font-size: 15px;
          }
        }
      }
      .card {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-left: auto;
        margin-right: auto;
        &.fast {
          .item {
            width: 90%;
            flex-direction: column;
            align-items: center;
            text-align: center;
            img {
              margin-right: 0;
              margin-bottom: 20px;
              width: 80px;
              height: 80px;
            }
            .desc {
              color: $text-color;
            }
            @media (min-width: $min-width-standard) {
              &.item {
                width: 30%;
              }
            }
          }
        }
        &.active {
          .item {
            width: 90%;
            flex-direction: column;
            align-items: center;
            text-align: center;
            padding: 10px 10px;
            img {
              margin-right: 0;
              margin-bottom: 20px;
              width: 350px;
              height: 200px;
            }
            @media (min-width: $min-width-standard) {
              &.item {
                width: 48%;
              }
            }
          }
        }
        .item {
          display: flex;
          align-items: center;
          justify-content: center;
          line-height: 32px;
          padding: 30px 15px;
          margin: 10px auto;
          @media screen and (max-width: $max-width-standard) {
            padding: 15px 15px;
          }
          // &:hover {
          //   background: #fff;
          //   box-shadow: 0px 0px 34px 8px rgba(93, 102, 172, 0.2);
          // }
          @media (min-width: $min-width-standard) {
            &.item {
              margin: 10px 0;
            }
          }
          img {
            display: block;
            flex-shrink: 0;
            width: 160px;
            height: 160px;
            object-fit: contain;
            margin-right: 30px;
            @media screen and (max-width: $max-width-standard) {
              width: 120px;
              height: 120px;
            }
          }
          .title {
            font-size: 16px;
            margin-bottom: 15px;
            @media screen and (max-width: $max-width-standard) {
              font-size: 15px;
            }
          }
          .desc {
            color: $text-grey;
            line-height: 22px;
            font-size: 14px;
            margin-bottom: 0;
            @media screen and (max-width: $max-width-standard) {
              font-size: 12px;
            }
          }
        }
      }
    }
    .news-right {
      width: 26%;
      .news-link {
        &:hover {
          color: $text-blue;
        }
      }
      .code {
        width: 160px;
      }
    }
  }
  .news-wrap-mobile {
    .news-left {
      width: 100%;
      margin-top: 40px;
      .content-wrap {
        p {
          margin-bottom: 14px;
        }
      }
      .video-wrap {
        width: 100%;
        height: 200px;
        .pic-video {
          width: 100%;
          height: 100%;
          display: block;
          background: url('../../assets/news/video.jpg');
          background-position-x: center;
          background-size: cover;
        }
      }
      .area {
        padding-bottom: 30px;
        // padding-top: 50px;
        .section-title {
          font-size: 20px;
          color: $text-blue;
          text-align: center;
          @media screen and (max-width: $max-width-standard) {
            font-size: 15px;
          }
        }
      }
      .card {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-left: auto;
        margin-right: auto;
        &.fast {
          .item {
            width: 90%;
            flex-direction: column;
            align-items: center;
            text-align: center;
            img {
              margin-right: 0;
              margin-bottom: 20px;
              width: 80px;
              height: 80px;
            }
            .desc {
              color: $text-color;
            }
            @media (min-width: $min-width-standard) {
              &.item {
                width: 30%;
              }
            }
            @media (max-width: 360px) {
              &.item {
                width: 90%;
              }
            }
          }
        }
        &.active {
          .item {
            width: 90%;
            flex-direction: column;
            align-items: center;
            text-align: center;
            padding: 10px 10px;
            img {
              margin-right: 0;
              margin-bottom: 20px;
              width: 100%;
              height: 150px;
              object-fit: cover;
            }
            @media (min-width: $min-width-standard) {
              &.item {
                width: 48%;
              }
            }
          }
        }
        .item {
          display: flex;
          align-items: center;
          justify-content: center;
          line-height: 32px;
          padding: 30px 15px;
          margin: 10px auto;
          @media screen and (max-width: $max-width-standard) {
            padding: 15px 15px;
          }
          // &:hover {
          //   background: #fff;
          //   box-shadow: 0px 0px 34px 8px rgba(93, 102, 172, 0.2);
          // }
          @media (min-width: $min-width-standard) {
            &.item {
              margin: 10px 0;
            }
          }
          img {
            display: block;
            flex-shrink: 0;
            width: 160px;
            height: 160px;
            object-fit: contain;
            margin-right: 30px;
            @media screen and (max-width: $max-width-standard) {
              width: 120px;
              height: 120px;
            }
          }
          .title {
            font-size: 20px;
            @media screen and (max-width: $max-width-standard) {
              font-size: 15px;
            }
          }
          .desc {
            color: $text-grey;
            line-height: 22px;
            font-size: 16px;
            margin-bottom: 0;
            @media screen and (max-width: $max-width-standard) {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}
</style>
